import { Component, inject, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { GoogleMapsLoaderService } from '../../../../../core/services/google-maps-loader.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import * as BUTTON_CONFIG from '../../../../../constants/button/index';
import { DefaultConstant } from '../../../../../constants/enum/common/default.enum';
import { CommonUtil } from '../../../../../core/utils/common-util';
import { DateUtil } from '../../../../../core/utils/date-util';
import { LocalStorageUtil } from '../../../../../core/utils/local-storage-util';

@Component({
  standalone: false,
  selector: 'kt-end-break',
  templateUrl: './end-break.component.html',
  styleUrls: ['./end-break.component.scss'],
})
export class EndBreakComponent implements OnInit, OnDestroy {
  buttonConfig = BUTTON_CONFIG;
  location = signal<any>({});
  shiftDetails: any = null;
  distanceFromActualLocation = 0;
  breakDetail = null;
  startTime = null;
  defaultEnum = DefaultConstant;
  currentTime = '';
  breakDuration = null;
  interval = null; 
  utcOffSet = LocalStorageUtil.getTimeZoneOffset();
  mapReady = signal(false);
  infoContent = '';
  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;
  private readonly mapsLoader = inject(GoogleMapsLoaderService);

  constructor(public activeModal: NgbActiveModal) { }

  openInfoWindow(marker: MapMarker, content: string) {
    this.infoContent = content;
    if (this.infoWindow) {
      this.infoWindow.open(marker);
    }
  }

  ngOnInit(): void {
    this.mapsLoader.load().then(() => this.mapReady.set(true));
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.location.set({ latitude: position.coords.latitude, longitude: position.coords.longitude });
        this.distanceFromActualLocation = CommonUtil.distance(position.coords.latitude, position.coords.longitude, (+this.shiftDetails.area.area_latitude), (+this.shiftDetails.area.area_longitude), 'K');
      });
    }
    this.getBreakDuration();
    this.getCurrentTime();
    this.interval = setInterval(() => {
      this.getBreakDuration();
      this.getCurrentTime();
    }, 1000);
  }


  // getBreakDuration() {
  //   this.startTime = moment(DateUtil.convertUtcToDate(this.breakDetail.timesheet_log_start_date)).format('DD/MM/YYYY hh:mm:ss a');
  //   this.breakDuration = Math.floor((DateUtil.getCurrentDateTime().utc().utcOffset(this.utcOffSet).diff(moment(this.breakDetail.timesheet_log_start_date).utc().utcOffset(this.utcOffSet))) / 60000);
  // }


  // getCurrentTime() {
  //   this.currentTime = DateUtil.getCurrentDateTime().format('DD/MM/YYYY hh:mm:ss a');
  // }

   getBreakDuration() {
    // this.startTime = moment(DateUtil.convertUtcToDate(this.breakDetail.timesheet_log_start_date)).format('DD/MM/YYYY hh:mm:ss a');
    // this.breakDuration = Math.floor((DateUtil.getCurrentDateTime().utc().utcOffset(this.utcOffSet).diff(moment(this.breakDetail.timesheet_log_start_date).utc().utcOffset(this.utcOffSet))) / 60000);

    // parse start date in its timezone
    const start = moment.tz(this.breakDetail.timesheet_log_start_date, 'YYYY-MM-DDTHH:mm:ss', this.shiftDetails.location.location_fk_timezone_name);

    this.startTime = start.format('DD/MM/YYYY hh:mm:ss a');

    // current time in same timezone
    const now = DateUtil.getCurrentDateTimeWithLocationTimezone(this.shiftDetails.location.location_fk_timezone_name);

    const diffInMinutes = Math.floor(now.diff(start) / 60000);
    const hours = Math.floor(diffInMinutes / 60);
    const minutes = diffInMinutes % 60;

    this.breakDuration = `${hours}Hrs ${minutes}Mins`;
  }


  getCurrentTime() {
    this.currentTime =  DateUtil.getCurrentDateTimeWithLocationTimezone(this.shiftDetails.location.location_fk_timezone_name).format('DD/MM/YYYY hh:mm:ss a');
  }

  endBreakHandler() {
    this.activeModal.close(true);
  }
  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}
